import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=5cce7c4a&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"
import style0 from "./Cards.vue?vue&type=style&index=0&id=5cce7c4a&prod&scoped=true&lang=scss"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=5cce7c4a&prod&scoped=true&lang=css&external"
import style2 from "./Cards.vue?vue&type=style&index=2&id=5cce7c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cce7c4a",
  null
  
)

export default component.exports